export const normalizeEditorId = (id: string) => id.replace(/^(\/home|\/attaches)\//, '/');
